import React from 'react';
import SafeIcon from '../common/SafeIcon';

const OriginMap = () => {
  return (
    <section className="py-24 md:py-32 bg-espresso text-cream relative overflow-hidden">
      {/* Decorative Top Border */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-moss/50 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative group">
              {/* The "Notebook" Page */}
              <div className="bg-cream-paper p-8 md:p-12 text-espresso transform -rotate-1 shadow-2xl border-l-[12px] border-espresso/10 transition-transform duration-500 group-hover:rotate-0">
                <div className="flex justify-between items-center mb-10 border-b-2 border-espresso/20 pb-6">
                  <div>
                    <h3 className="font-serif text-3xl font-bold mb-1">Field Journal</h3>
                    <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-gray-400">Current Observations — Vol. VII</p>
                  </div>
                  <div className="text-right">
                    <span className="font-handwriting text-3xl text-moss">2024</span>
                  </div>
                </div>

                <div className="space-y-8">
                  <div className="flex gap-6">
                    <div className="shrink-0 w-12 h-12 bg-espresso text-cream flex items-center justify-center font-serif text-2xl italic">01</div>
                    <div>
                      <h4 className="font-bold text-sm uppercase tracking-widest mb-1">Honduras — Marcala</h4>
                      <p className="text-sm text-gray-600 italic leading-relaxed">"Exceptional clarity this season. The jasmine notes are particularly vibrant due to the late rainfall. Processing at El Puente is flawless."</p>
                    </div>
                  </div>
                  <div className="flex gap-6">
                    <div className="shrink-0 w-12 h-12 bg-moss text-cream flex items-center justify-center font-serif text-2xl italic">02</div>
                    <div>
                      <h4 className="font-bold text-sm uppercase tracking-widest mb-1">Ethiopia — Shakisso</h4>
                      <p className="text-sm text-gray-600 italic leading-relaxed">"Classic Guji profile. The natural process has yielded a winey, berry-heavy cup that will anchor our Light Roast series."</p>
                    </div>
                  </div>
                </div>

                <div className="mt-12 pt-8 border-t border-espresso/10 flex justify-between items-center">
                  <img src="https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&q=80&w=100" className="w-20 h-20 object-cover grayscale rounded-full border-4 border-white shadow-lg" alt="Stamp" />
                  <div className="text-right">
                    <p className="font-handwriting text-xl text-espresso/60 italic">Certified Traceable</p>
                    <p className="text-[9px] uppercase tracking-widest font-bold">QA Signed: J. Miller</p>
                  </div>
                </div>
              </div>

              {/* Stacked paper effect */}
              <div className="absolute inset-0 bg-cream-dark -z-10 translate-x-3 translate-y-3 rotate-1 shadow-xl"></div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="inline-flex items-center gap-3 mb-8 px-4 py-2 bg-white/5 rounded-full backdrop-blur-sm border border-white/10">
              <SafeIcon name="MapPin" className="text-moss-light" />
              <span className="font-bold tracking-[0.2em] uppercase text-[10px] text-cream-dark">Global Sourcing Ethics</span>
            </div>
            
            <h2 className="font-serif text-5xl md:text-7xl font-bold mb-8 leading-[1.1]">
              Coffee without <br/>
              <span className="text-moss-light">Boundaries.</span>
            </h2>
            
            <p className="text-lg text-cream-dark/80 mb-10 font-light leading-relaxed max-w-xl">
              We don't just buy coffee; we invest in communities. Through direct-trade partnerships, we ensure that the premiums we pay go directly back into farm infrastructure and local education.
            </p>
            
            <div className="grid grid-cols-2 gap-12 border-t border-white/10 pt-10">
              <div>
                <p className="text-5xl font-serif font-bold text-moss-light mb-2">100%</p>
                <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-cream-dark">Directly Traced</p>
              </div>
              <div>
                <p className="text-5xl font-serif font-bold text-moss-light mb-2">3.5x</p>
                <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-cream-dark">Above Fair Trade</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OriginMap;